export default {
  setList(state, list) {
    state.list = [...state.list, ...list];
  },

  setPage(state, page = 1) {
    state.page = page;
  },

  setTotalPage(state, totalPage = 2) {
    state.totalPage = totalPage;
  },

  setPageInit(state) {
    state.page = 1;
    state.totalPage = 2;
  },

  setListInit(state) {
    state.list = [];
  },

  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },

  setDetail(state, data) {
    state.detail = data;
  }
};
